function stripPostcode() {
    'ngInject';
    
    return function (address) {
        // test to see if the address contains a postcode by searching for a any
        // letter followed by a number i.e N1, CM11
        const match = address.toLowerCase().match(/[a-z]+\d/);
        // if there's a match, get the index of the match and remove postcode
        if (match) {
            address = address.substr(0, match.index);
        }
        // trim white space
        address = $.trim(address);
        //  remove trailing comma if there is one
        if (/,$/.test(address)) {
            address = address.slice(0, -1);
        }

        return address;
    };
}

// strips the postcode from the end of the address. i.e.
// '15 some address, somwhere, SS1 4RP' becomes '15 some address, somwhere'
angular
    .module('BB')
    .filter('stripPostcode', stripPostcode);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/strip_postcode.filter.js